<template>
  <a-entity id="frame">
    <a-box
      src="#frame"
      repeat="1 4"
      :width="frameWidth"
      :height="fullWidth"
      :depth="frameDepth"
      rotation="0 0 90"
      :position="`0 ${fullHeight / 2 - frameWidth / 2} ${
        (frameDepth + 0.005) / 2
      }`"
    ></a-box>

    <a-box
      src="#frame"
      repeat="1 4"
      offset=".25 .25"
      :width="frameWidth"
      :height="fullWidth"
      :depth="frameDepth"
      rotation="0 0 90"
      :position="`0 -${fullHeight / 2 - frameWidth / 2} ${
        (frameDepth + 0.005) / 2
      }`"
    ></a-box>

    <a-box
      src="#frame"
      repeat="1 4"
      offset=".25 .25"
      :width="frameWidth"
      :height="fullHeight"
      :depth="frameDepth"
      :position="`${fullWidth / 2 - frameWidth / 2} 0 ${frameDepth / 2}`"
    ></a-box>
    <a-box
      src="#frame"
      repeat="1 4"
      :width="frameWidth"
      :height="fullHeight"
      :depth="frameDepth"
      :position="`-${fullWidth / 2 - frameWidth / 2} 0 ${frameDepth / 2}`"
    ></a-box>
  </a-entity>
</template>

<script>
export default {
  name: "VrFrame",
  data: function () {
    return { frameWidth: 0.2, frameDepth: 0.025 };
  },
  props: {
    width: {
      type: Number,
      default: 1.8,
    },
    height: {
      type: Number,
      default: 1.93,
    },
  },
  computed: {
    fullWidth: function () {
      return this.width + this.frameWidth * 2;
    },
    fullHeight: function () {
      return this.height + this.frameWidth * 2;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
